/**
 * Format a numeric value as XAF currency, respecting the user's locale.
 *
 * @param {number} value
 * @param {string} locale  The i18n lang code, e.g. 'en' or 'fr'
 * @returns {string}  e.g. "1,234 XAF" (en) or "1 234 XAF" (fr)
 */
export default function currencyXAF (value, locale = 'en') {
  if (typeof value !== 'number') return value
  const tag = locale === 'fr' ? 'fr-FR' : 'en-US'
  const formatted = value.toLocaleString(tag, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })
  return `${formatted} XAF`
}
